import { render, staticRenderFns } from "./quesMedia.vue?vue&type=template&id=2a7f05fb"
import script from "./quesMedia.vue?vue&type=script&lang=js"
export * from "./quesMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports